import { createClient } from "@supabase/supabase-js";

// Auto-detect backend URL: env var → same origin (self-hosted)
const supabaseUrl =
  process.env.REACT_APP_SUPABASE_URL ||
  process.env.VITE_SUPABASE_URL ||
  window.location.origin;
const supabaseKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  process.env.VITE_SUPABASE_ANON_KEY ||
  "local-self-hosted";

// Create Supabase client - use placeholder if env vars not set (app will still render)
let supabase;
try {
  if (
    supabaseUrl &&
    supabaseKey &&
    supabaseUrl !== "your_supabase_project_url" &&
    supabaseKey !== "your_supabase_anon_key"
  ) {
    supabase = createClient(supabaseUrl, supabaseKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
      },
    });
    console.log("✅ Supabase client initialized successfully");
  } else {
    // Create a dummy client that won't crash the app
    supabase = createClient(
      "https://placeholder.supabase.co",
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBsYWNlaG9sZGVyIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NDUxOTIwMDAsImV4cCI6MTk2MDc2ODAwMH0.placeholder",
      {
        auth: {
          autoRefreshToken: false,
          persistSession: false,
          detectSessionInUrl: false,
        },
      },
    );
    console.warn(
      "⚠️ Using placeholder Supabase client - please configure your environment variables",
    );
  }
} catch (error) {
  console.error("❌ Error initializing Supabase:", error);
  // Create minimal client to prevent app crash
  supabase = createClient("https://placeholder.supabase.co", "placeholder-key");
}

export { supabase };
export default supabase;

// Export credentials for error logging
export const getSupabaseConfig = () => ({
  url: supabaseUrl,
  key: supabaseKey,
});

// Helper functions for common database operations
export const getServerTimestamp = () => {
  return new Date().toISOString();
};

// Collection references for quick access
export const TABLES = {
  USERS: "users",
  PRODUCTS: "products",
  CATEGORIES: "categories",
  ORDERS: "orders",
  WALLET_TRANSACTIONS: "wallet_transactions",
  WALLET_HISTORY: "wallet_history",
  REVIEWS: "reviews",
  COUPONS: "coupons",
  VENDORS: "vendors",
  INVENTORY: "inventory",
  WISHLISTS: "wishlists",
  CARTS: "carts",
  SHIPPING_METHODS: "shipping_methods",
  PAYMENT_METHODS: "payment_methods",
  BANNERS: "banners",
  SETTINGS: "settings",
  ANALYTICS: "analytics",
};

console.log("Database tables configured:", Object.keys(TABLES));
